const MAX_KEY_LENGTH = 64;

/** A template key derived from its name: lowercase words joined by underscores, starting with a letter. */
export function keyFromName(name: string): string {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^[^a-z]+/, '')
    .slice(0, MAX_KEY_LENGTH)
    .replace(/_+$/, '');
}
